import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=e810bc34&scoped=true&"
import script from "./productDetails.vue?vue&type=script&lang=js&"
export * from "./productDetails.vue?vue&type=script&lang=js&"
import style0 from "./productDetails.vue?vue&type=style&index=0&id=e810bc34&prod&lang=less&scoped=true&"
import style1 from "./productDetails.vue?vue&type=style&index=1&id=e810bc34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e810bc34",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PicZoom: require('/app/components/picZoom/picZoom.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,Tooltip: require('/app/components/tooltip.vue').default})
